import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from 'react-toastify';
import store from "redux/store";
import { GET_ASSIGNVEHICLE_FAILED, GET_ASSIGNVEHICLE_REQUESTED, GET_ASSIGNVEHICLE_SUCCESS, GET_LISTASSIGNEDVEHICLE_FAILED, GET_LISTASSIGNEDVEHICLE_REQUESTED, GET_LISTASSIGNEDVEHICLE_SUCCESS, GET_REQUESTVEHICLE_FAILED, GET_REQUESTVEHICLE_REQUESTED, GET_REQUESTVEHICLE_SUCCESS, GET_UPDATEASSIGNDRIVER_FAILED, GET_UPDATEASSIGNDRIVER_REQUESTED, GET_UPDATEASSIGNDRIVER_SUCCESS, GET_UPDATEASSIGNVEHICLE_FAILED, GET_UPDATEASSIGNVEHICLE_REQUESTED, GET_UPDATEASSIGNVEHICLE_SUCCESS,GET_ASSIGN_DRIVER_FAILED, GET_ASSIGN_DRIVER_REQUESTED, GET_ASSIGN_DRIVER_SUCCESS, GET_UPDATEASSIGNSUBVENDOR_SUCCESS, GET_UPDATEASSIGNSUBVENDOR_FAILED, GET_UPDATEASSIGNSUBVENDOR_REQUESTED } from "resources/actionTypes";
import { assignVehicleApi, listAssignedVehicleApi, requestVehicleApi, updateAssignDriverApi, updateAssignVehicleApi,assignDriverApi, updateAssignSubVendorApi } from "services/AllotService";
import { getRequestVehicle } from "redux/actions/UserAllot";
import { getDriver } from "redux/actions/UserDriver";
import { getSubVendor } from "redux/actions/UserSubVendor";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchRequestVehicle(action) {
  try {
    const payload = action.payload || {}
    const userRequestVehicle = yield call(requestVehicleApi, payload);
    yield put({ type: GET_REQUESTVEHICLE_SUCCESS, userRequestVehicle: userRequestVehicle });
  } catch (e) {
    yield put({ type: GET_REQUESTVEHICLE_FAILED, message: e.message });
  }
}

export function* requestVehicleSaga() {
  yield takeEvery(GET_REQUESTVEHICLE_REQUESTED, fetchRequestVehicle);
}

function* fetchListAssignedVehicle(action) {
  try {
    const payload = action.payload || {}
    const userListAssignedVehicle = yield call(listAssignedVehicleApi, payload);
    yield put({ type: GET_LISTASSIGNEDVEHICLE_SUCCESS, userListAssignedVehicle: userListAssignedVehicle });
  } catch (e) {
    yield put({ type: GET_LISTASSIGNEDVEHICLE_FAILED, message: e.message });
  }
}

export function* listAssignedVehicleSaga() {
  yield takeEvery(GET_LISTASSIGNEDVEHICLE_REQUESTED, fetchListAssignedVehicle);
}

function* fetchAssignVehicle(action) {
  try {
    const payload = action.payload || {}
    const userAssignVehicle = yield call(assignVehicleApi, payload);
    yield put({ type: GET_ASSIGNVEHICLE_SUCCESS, userAssignVehicle: userAssignVehicle });
  } catch (e) {
    yield put({ type: GET_ASSIGNVEHICLE_FAILED, message: e.message });
  }
}

export function* assignVehicleSaga() {
  yield takeEvery(GET_ASSIGNVEHICLE_REQUESTED, fetchAssignVehicle);
}

function* fetchUpdateAssignVehicle(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const userUpdateAssignVehicle = yield call(updateAssignVehicleApi, payload?.userUpdateAssignVehicle);
  if (userUpdateAssignVehicle.success) {
    yield put({ type: GET_UPDATEASSIGNVEHICLE_SUCCESS, userUpdateAssignVehicle: userUpdateAssignVehicle });
    toast.success(userUpdateAssignVehicle.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userUpdateAssignVehicle?.unAssined !== 'unAssined'){
      payload?.setConfirmModal();
    }
    store.dispatch(getRequestVehicle({ status: '', page: "", pageSize: "", type: payload?.userUpdateAssignVehicle?.type }));
    store.dispatch(getDriver(payload?.userUpdateAssignVehicle?.driverData))
  } else {
    yield put({ type: GET_UPDATEASSIGNVEHICLE_FAILED, message: userUpdateAssignVehicle.message });
    store.dispatch(onLoaderTrigger(false));
      toast.error(userUpdateAssignVehicle?.message || 'Update Assign Vehicle failed');
  }
}
export function* updateAssignVehicleSaga() {
  yield takeEvery(GET_UPDATEASSIGNVEHICLE_REQUESTED, fetchUpdateAssignVehicle);

}

function* fetchUpdateAssignDriver(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const userUpdateAssignDriver = yield call(updateAssignDriverApi, payload?.userUpdateAssignDriver);
  if (userUpdateAssignDriver.success) {
    yield put({ type: GET_UPDATEASSIGNDRIVER_SUCCESS, userUpdateAssignDriver: userUpdateAssignDriver });
    toast.success(userUpdateAssignDriver.message);
    store.dispatch(onLoaderTrigger(false));
    payload?.setConfirmModal();
    if(payload?.userUpdateAssignDriver?.rideTrip){
      store.dispatch(getDriver(payload?.userUpdateAssignDriver?.driverData))
    }else{
     store.dispatch(getDriver(payload?.userUpdateAssignDriver?.driverData))
    }
  } else {
    yield put({ type: GET_UPDATEASSIGNDRIVER_FAILED, message: userUpdateAssignDriver.message });
    store.dispatch(onLoaderTrigger(false));
    toast.error(userUpdateAssignDriver?.message || 'Update Assign Driver failed' );
  }
}
export function* updateAssignDriverSaga() {
  yield takeEvery(GET_UPDATEASSIGNDRIVER_REQUESTED, fetchUpdateAssignDriver)
}

function* fetchAssignDriver(action) {
  try {
    const payload = action.payload || {}
    const userAssignDriver = yield call(assignDriverApi,payload);
    yield put({ type: GET_ASSIGN_DRIVER_SUCCESS, userAssignDriver: userAssignDriver });
  } catch (e) {
    yield put({ type: GET_ASSIGN_DRIVER_FAILED, message: e.message });
  }
}

export function* assignDriverSaga() {
  yield takeEvery(GET_ASSIGN_DRIVER_REQUESTED, fetchAssignDriver);
}

function* fetchUpdateAssignSubVendor(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {}
  const userUpdateAssignSubVendor = yield call(updateAssignSubVendorApi, payload.userUpdateAssignSubVendor);
  if (userUpdateAssignSubVendor?.success) {
    yield put({ type: GET_UPDATEASSIGNSUBVENDOR_SUCCESS, userUpdateAssignSubVendor: userUpdateAssignSubVendor });
    toast.success(userUpdateAssignSubVendor.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userUpdateAssignSubVendor?.unAssined !== 'unAssined'){
      payload?.setConfirmModal();
    }
    store.dispatch(getDriver({ page: "", pageSize: "", allot: payload?.userUpdateAssignSubVendor?.allot, assignId: payload?.userUpdateAssignSubVendor?.assignId, type: '' }));
    store.dispatch(getSubVendor(payload?.userUpdateAssignSubVendor?.subVendorData))
  } else {
    yield put({ type: GET_UPDATEASSIGNSUBVENDOR_FAILED, message: userUpdateAssignSubVendor.message });
    store.dispatch(onLoaderTrigger(false));
    toast.error(userUpdateAssignSubVendor?.message || 'Update Assign SubVendor failed');
  }
}
export function* updateAssignSubVendorSaga() {
  yield takeEvery(GET_UPDATEASSIGNSUBVENDOR_REQUESTED, fetchUpdateAssignSubVendor)
}

